module.exports = __webpack_public_path__ + "img/superpowers_en.c6fdaae.jpg";